import { upload } from '@vercel/blob/client';

/**
 * Upload une image vers Vercel Blob et retourne l'URL publique.
 * @param {File} file - Le fichier image
 * @param {string} token - Le token JWT admin
 */
export async function uploadImage(file, token) {
  try {
    const blob = await upload(file.name, file, {
      access: 'public',
      handleUploadUrl: '/api/admin/upload-token',
      clientPayload: token,
    });
    return blob.url;
  } catch (err) {
    // Tenter de récupérer un message serveur plus explicite
    if (err.message?.includes('retrieve the client token')) {
      throw new Error(
        'Impossible d\'uploader l\'image — vérifiez que BLOB_READ_WRITE_TOKEN est configuré dans les variables d\'environnement Vercel (dashboard → Storage → Blob)'
      );
    }
    throw err;
  }
}

/**
 * Sauvegarde une collection complète dans Neon via l'API admin.
 * @param {string} name - Nom de la collection
 * @param {*} data - Données à sauvegarder
 * @param {string} token - Le token JWT admin
 */
export async function saveCollection(name, data, token) {
  const res = await fetch(`/api/admin/collection?name=${name}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ data }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Erreur réseau' }));
    throw new Error(err.error || 'Erreur lors de la sauvegarde');
  }

  const result = await res.json();
  return result.data;
}
